import React from 'react';
import { Atom } from 'AppReact';

const EmbeddedPDF = ({ url }) => {
  return (
    <embed width="100%" height="100%" name="plugin" src={url} type="application/pdf" />
  )
}

export default Atom({ type: 'custom', dataType: 'string', template: EmbeddedPDF });
